// extracted by mini-css-extract-plugin
module.exports = {"component":"configuration-flow-pax-selector_component__dvWZf","paxInfo":"configuration-flow-pax-selector_paxInfo__GRqo8","link":"configuration-flow-pax-selector_link__8YU5e"};